import React from "react";
import { ReactComponent as InfoIcon } from "../../assets/icons/management/info.svg";
import { IProduct } from "../../types/product.type";
import { formatDate } from "../../utils/formatDate";
import { getWarehouseCount } from "../../utils/getWarehouseCount";
import styles from "./styles.module.scss";

interface Props {
  products: IProduct[];
  callBackInfo: (bool: boolean) => void;
  callBackEdit: (product: IProduct) => void;
}

const WarehouseTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Product</th>
          <th>Count</th>
          <th>Batch</th>
          <th>Quantity</th>
          <th>Date</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.products &&
          props.products.map((user, index) => {
            const counts = getWarehouseCount(user);
            const filtredProduct = user.batches.filter(
              (item) => item.batchQuantity !== 0
            );
            return (
              <tr key={user.id}>
                <td>
                  <div className={styles.userInfo}>
                    {user.previewImageUrl ? (
                      <img
                        src={user.previewImageUrl}
                        className={styles.avatar}
                        alt="Resource"
                      />
                    ) : (
                      <div className={styles.avatar}></div>
                    )}
                    <div className={styles.nameContainer}>
                      <span className={styles.name}>{user.name}</span>
                      <span className={styles.email}>
                        {user.brand.name}, {user.capacity}
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <span className={styles.email}>{counts}</span>
                </td>
                <td className={styles.role}>
                  {filtredProduct.map((item) => (
                    <p className={styles.email}>{item.batchName}</p>
                  ))}
                </td>
                <td className={styles.role}>
                  {filtredProduct.map((item) => (
                    <p className={styles.email}>{item.batchQuantity}</p>
                  ))}
                </td>
                <td className={styles.role}>
                  {filtredProduct.map((item) => (
                    <p className={styles.email}>{formatDate(item.batchDate)}</p>
                  ))}
                </td>
                <td>
                  <div className={styles.actions}>
                    <button
                      className={styles.infoBtn}
                      onClick={() => {
                        props.callBackInfo(true);
                        props.callBackEdit(user);
                      }}
                    >
                      <InfoIcon />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export default WarehouseTable;
